module.exports = __webpack_public_path__ + "static/media/github.c40ccb4c.png";